import React, { FC } from 'react';
import { colors } from './constants/designTokens';
import { HighlightedHeader } from '@edreamsodigeo/prisma-design-system';
import { useFlowTools } from 'flowTools/useFlowTools';

export const DealHeader: FC = ({ ...props }) => {
  const { isDesktop } = useFlowTools();
  const pad = isDesktop ? 0 : 3;
  return (
    <HighlightedHeader
      {...props}
      size="full"
      type="positive"
      sx={{
        background: colors.deal.backgroundGradient,
        paddingBottom: pad,
      }}
    />
  );
};
